var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a Commission"},on:{"on-hide":_vm.resetFormData}},[_c('commissions-form',{key:_vm.formKey,attrs:{"location_id":_vm.location_id},on:{"on-submit":_vm.createCommission,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }